module.exports = __webpack_public_path__ + "img/10.2dbed1d6.png";